import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Browser } from '@capacitor/browser';
import {
  IonButton,
  IonButtons,
  IonFooter,
  IonHeader,
  IonIcon,
  IonRippleEffect,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgIf } from '@angular/common';
import { IonContent } from '@ionic/angular/standalone';
import { DivClickDirective } from 'src/app/directives/div-click.directive';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AnalyticsType } from 'src/app/enums/analytics-type';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.page.html',
  standalone: true,
  imports: [
    NgIf,
    InlineSVGModule,
    DivClickDirective,
    TranslateModule,
    IonContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    RouterModule,
    IonRippleEffect,
    IonIcon,
    IonFooter,
  ],
})
export class OnboardingPage {
  appIcon: string;
  appName: string;

  constructor(
    private app: CurrentWhiteLabelApplication,
    private router: Router,
    private analyticsService: AnalyticsService,
    private settingsService: SettingsService
  ) {
    this.appIcon = this.app.getIconThumbnails()?.small;
    this.appName = this.app.getName();
  }

  skip() {
    this.router.navigate(['feed'], { replaceUrl: true });
  }

  chooseArea() {
    this.router.navigate(['onboarding', 'address', 'create']);
    this.analyticsService.logEvent(AnalyticsType.ONBOARDING_AREA, {});
  }

  chooseProjects() {
    this.router.navigate(['onboarding', 'search']);
    this.analyticsService.logEvent(AnalyticsType.ONBOARDING_PROJECTS, {});
  }

  async openPrivacyStatement() {
    Browser.open({
      url: this.settingsService.getPriavacyStatementUrl(this.app.getPlatform()),
    });
  }

  openLoginPage() {
    this.router.navigate(['onboarding', 'login']);
    this.analyticsService.logEvent(AnalyticsType.ONBOARDING_LOGIN, {});
  }
}
